module.exports = __webpack_public_path__ + "black_row.png";